<template>
  <div class="dictionaries-fields-list">
    <div class="d-sm-flex justify-content-end">
      <pcg-btn variant="additional" v-b-modal.add-modal size="small"
               class="w-100 w-sm-auto m-0 font-weight-bold"
      >
        + {{ $t('general.new_profile') }}
      </pcg-btn>
    </div>

    <dictionary-table
        :edit-resource="editResource"
        :destroy-resource="destroyResource"
        :items="items"
        resource-name="studyProfile"
        url="study_profiles"
    />

    <structure-modal
        :action="action(studyProfile, 'study_profiles')"
        :btn-title="btnTitle"
        :editMode="editMode"
        :errors="errors"
        :modalId="editMode ? 'edit-modal' : 'add-modal'"
        :title-modal="title"
        v-bind.sync="studyProfile"
        @hidden="hideModal('studyProfile')"
        @clear-error="errors[$event] = ''"
    />
  </div>
</template>

<script>
import StructureModal from '../../components/dictionaries/shared/StructureModal'
import DictionaryTable
  from '../../components/dictionaries/shared/DictionaryTable'
import useList from '../../composables/useList'
import useDictionary from '../../composables/useDictionary'
import { dictionary } from '../../mixins/dictionary'

export default {
  name: 'DictionaryProfiles',
  setup (props, { root }) {
    const {
      items, setItems, removeRow, findItemById,
    } = useList(root)
    const {
      addResource,
      clearModel,
      destroyResource,
      editMode,
      editResource,
      errors,
      updateResource,
    } = useDictionary()
    return {
      addResource,
      clearModel,
      destroyResource,
      editMode,
      editResource,
      errors,
      findItemById,
      items,
      removeRow,
      setItems,
      updateResource,
    }
  },
  components: {
    DictionaryTable,
    StructureModal,
  },
  mixins: [dictionary],
  data () {
    return {
      studyProfile: {
        name: '',
        [Symbol.for('_innerName')]: 'studyProfile',
      },
    }
  },
  computed: {
    title () {
      if (this.editMode) {
        return this.$t('general.edit_profile')
      } else {
        return this.$t('general.new_profile')
      }
    },
    btnTitle () {
      if (this.editMode) {
        return this.$t('general.update')
      } else {
        return this.$t('general.add_profile')
      }
    },
  },
  created () {
    this.getStudyProfiles()
  },
  methods: {
    async getStudyProfiles () {
      let { data: studyProfiles } = await this.$api.get('study_profiles')
      studyProfiles = studyProfiles.map(studyProfile => {
        return {
          id: studyProfile.id,
          name: studyProfile.attributes.name,
        }
      })
      this.setItems(studyProfiles)
    },

    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.header.dictionary.title'),
        subtitle: this.$tc('general.profile', 2),
      })
    },
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  },
}
</script>
